import React, { Component } from 'react'
import Slider from 'react-slick'

//dependences: react-slick
import style from './style.css'

export default class SlickSlider extends Component {
  render() {
    function NextArrow(props) {
        const {onClick} = props
        return (
            <button className={`${style.next}`} onClick={onClick}></button>
        );
    }
    function PrevArrow(props) {
        const {onClick} = props
        return (
            <button className={`${style.prev}`} onClick={onClick}></button>
        );
    }

    const settings = {
        dots: (this.props.dots !== undefined ? this.props.dots : true),
        infinite: false,
        speed: 500,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
        slidesToShow: this.props.itens || 3,
        slidesToScroll: this.props.itens || 3,
        arrows: this.props.arrows,
        draggable: this.props.draggable || false,
        centerMode: this.props.centerMode || false,
        centerPadding: this.props.centerPadding || '30px',
        responsive: [
            {
                breakpoint: 700,
                settings: {
                    dots: true,
                    draggable: true,
                    arrows: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true,
                    centerPadding: this.props.centerPadding || '30px',
                }
            },
        ]
    }

    return (
        <Slider {...settings} className={`${style.slickslider} ${this.props.color ? style[this.props.color] : ''}`}>
            {this.props.children}            
        </Slider>
    )
  }
}

export class SlickItem extends Component {
    render() {
        return (
            <div className={`${style.itemWrap}`}>
                {this.props.children}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/third-party/SlickCarousel/index.js